import React from "react";
import JoinUs from "./JoinUs";
import AboutUsBanner from "./AboutUsBanner";
import HomeBanner from "./HomeBanner";
import Mission from "./Mission";
import HomeCarousel from "./HomeCarousel";
import RecentActivities from "./RecentActivities";
import PrincipleAdviserMember from "./PrincipleAdviserMember";
import JoinUsBanner from "./JoinUsBanner";
import TopDonor from "./TopDonor";
import ActivitiesSummary from "./ActivitiesSummary";
import SummaryBanner from "./SummaryBanner";
import PresidentMessage from "./PresidentMessage";
import ChiefPatronMember from "./ChiefPatronMember";

const Home = () => {
  return (
    <div>
      <div className="mx-2 md:mx-5 lg:mx-10">
        <HomeCarousel />
        <SummaryBanner />
        <RecentActivities />
        <HomeBanner />
        <JoinUs />
        <PrincipleAdviserMember />
        <ChiefPatronMember />
        <PresidentMessage />
        <Mission />
        <TopDonor />
        <ActivitiesSummary />
        <AboutUsBanner />
        <JoinUsBanner />
      </div>
    </div>
  );
};

export default Home;
